import React from 'react';
import { Typography } from '@mui/material';

// @desc Number of Section
const IndexNumber = ({ number }) => {
  return <Typography variant='indexNumber'>{number}</Typography>;
};

export default IndexNumber;
